import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    save: translate({ id: 'settings.rmAccount.edit.footer.save' }),
    cancel: translate({ id: 'settings.rmAccount.edit.footer.cancel' }),
  }))

  return api
}
